import React from 'react'

export default function FrontVideoSlider (props)
{
	const show_video = false;

	return (
		<div className="front-video-and-slider">

			{
				show_video ?
				(
					<div className="front-video-and-slider__video">

						<div className="iframe-16:9">
							<iframe src="https://www.youtube-nocookie.com/embed/ehbeW4LacBg?rel=0&controls=0" title="Synergies - 30 ans déjà" allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullscreen>
							</iframe>
						</div>

					</div>
				)
				: undefined
			}

			<div className="front-video-and-slider__slider">
				{ props.children }
			</div>

		</div>
	);
}